<template>
<el-dialog :close-on-click-modal="false" width="40%" :title="$t('IMPORT_ENTITY_BUTTON')" :visible="visible" @close="onDialogClose">
  <div class="form-wrapper">
    <div class="form-label">
      {{$t('ENTITY_FILE_NAME_LABEL')}}
    </div>
    <div class="form-component">
      <el-upload class="logo-uploader" action="url" :http-request="uploadFiles" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
        <el-input readonly suffix-icon="el-icon-folder-opened" v-model="fileName"></el-input>
      </el-upload>
    </div>
  </div>
  <div v-show="errorMessage" class="form-wrapper error-message">
    <div class="form-label">{{$t('ERROR_DETAIL_LABEL')}}</div>
    <div class="form-component">
      <div>{{errorMessage}}</div>
    </div>
  </div>
  <div style="color: #fd349c">
    <div><i class="el-icon-warning" />{{ $t('entity_upload_info_title')}}</div>
    <ul>
      <li>{{ $t('entity_upload_info1')}}</li>
      <li>{{ $t('entity_upload_info2')}}</li>
    </ul>
  </div>
  <div slot="footer" class="dialog-footer">
    <el-button @click="download">{{$t('COMMON_DOWNLOAD_TEMP')}}</el-button>
    <el-button type="primary" @click="onDialogClose" class="wl-green">{{$t('CLOSE_BUTTON')}}</el-button>
  </div>
</el-dialog>
</template>

<script>
import API from '@/api'
import { loading, isIE } from '@/utils'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    siteId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fileName: '',
      errorMessage: '',
      loading: loading(),
    }
  },
  watch: {
    visible(n, o) {
      this.errorMessage = ''
      this.fileName = ''
    }
  },
  methods: {
    async download() {
        try {
            const res = await API.general.downloadEntityTemplate()
            if (res) {
                let blob = new Blob([res])
                if (isIE()) {
                    navigator.msSaveBlob(blob, 'EntityTemplate.xlsx')
                } else {
                    let url = window.URL.createObjectURL(blob)
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download', 'EntityTemplate.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }
            }
        }
        catch(e) {}
        finally {}
    },
    showUploadDialog() {
      this.errorMessage = '';
      this.fileName = '';
      document.getElementById('uploadEntity').click()
    },
    handleAvatarSuccess(res, file) {
      
    },
    beforeAvatarUpload(file) {
      const isExcel =
        file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isExcel) {
        this.$message.error(this.$t('import_file_type_error'))
      }
      if (!isLt2M) {
        this.$message.error(this.$t('import_file_size_error'))
      }
      return isExcel && isLt2M
    },
    onDialogClose() {
      this.$emit('onDialogClose')
    },
    uploadFiles(item) {
      this.fileName = item.file.name
      let fileParams = new FormData()
      fileParams.append('siteId', this.siteId)
      fileParams.append('file', item.file)
      this.upload(fileParams)
    },
    async upload(fileParams) {
      this.loading.upload();
      try {
        const {
          data,
          code,
          errDetails
        } = await API.general.uploadEntityFile(fileParams)
        if (code == '1') {
          this.$message.success(this.$t('file_import_success'))
          this.$emit('on-upload-success')
        } else {
          if(code == 'Site_NAME_INCORRECT_001' || code == 'ENTITIES_ASSOCIATION_INCORRECT_001' || code == 'ENTITY_IMPORT_010'){
            this.errorMessage = this.$t(code)
          } else {
            this.errorMessage = errDetails.msg
          }
        }
      } catch (e) {
        this.$message.error(e)
      } finally {
        this.loading.close()
      }
    }
  }
}
</script>

<style scoped>
.error-message {
  color: #f56c6c;
  font-size: 14px;
}

.form-wrapper {
  display: flex;
  align-items: center;
}
.form-wrapper:first-child {
  margin-bottom: 20px;
}

.form-wrapper .form-label {
  min-width: 120px;
}
</style>
